module.exports = __webpack_public_path__ + "media/images/slider004-b8968060f53595155602f72cefdba51a.jpg";